import { ImageType } from '@d-id/types';
import { atom } from 'recoil';

export const DEFAULT_VIDEO_NAME = 'Untitled video';
export const GET_PRESENTERS_KEY = 'GET_PRESENTERS_KEY';
export const GET_PRESENTERS_KEY_TYPE = (type: ImageType) => `GET_PRESENTERS_QUERY_${type}`;
export const DEFAULT_CLIP_BACKGROUND = '#f1f2f6';

export const isImageProcessing = atom({
    key: 'is-image-processing',
    default: false,
});
